import { render, staticRenderFns } from "./AdministrationBreadcrumb.vue?vue&type=template&id=1ba7d68c&scoped=true&"
import script from "./AdministrationBreadcrumb.vue?vue&type=script&lang=ts&"
export * from "./AdministrationBreadcrumb.vue?vue&type=script&lang=ts&"
import style0 from "./AdministrationBreadcrumb.vue?vue&type=style&index=0&id=1ba7d68c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba7d68c",
  null
  
)

export default component.exports